module.exports = __webpack_public_path__ + "img/SKMJ_standard6.a72d874e.png";